<template>
	<div class="page" :class="$store.state.mode">
		<div class="navbar" :class="($store.state.mode === 'dark') ? 'darkHeaderActive' : 'false'">
			<transition name="slide-fade" mode="out-in">
				<i v-on:click="$router.go(-1)" class="material-icons">arrow_back</i>
			</transition>
			<div class="title">
				Back
			</div>			
		</div>
		<div class="search--wrapper">
			<div class="title">
				Search
			</div>
			<input class="input-search" :class="($store.state.mode === 'dark') ? 'dark-input-search' : 'false'" v-model="search" type="text" placeholder="Creators, audios..."/>
		</div>
		<!-- Creator search -->
		<div class="heading" v-show="search.length != 0" v-if="creatorSearch.length > 0">
			<div class="title">Searching for "{{ search.substring(0,12) }}{{ search.length >= 12 ? '...' : ''}}" </div>
			<div class="subtitle">best match by creator</div>
		</div>
		<div class="heading" v-show="search.length == 0" v-if="creatorSearch.length > 0">
			<div class="title">Popular Creator</div>
			<div class="subtitle">by editor's choice</div>
		</div>
		<div class="audio-card--wrapper">
			<div v-for="(item, index) in creatorSearch" :key="index" class="img--wrapper">
				<div v-ripple class="ripple">
					<div 
						@click="$router.push({ name: 'ProfileCreator', params: { id: item.id }})"
						:style="{ backgroundImage: `linear-gradient(rgba(255,255,255, 0), rgba(0, 0, 0, 1)), url(${item.cover})`}"
						class="image-audio">
					</div>
				</div>
				<div class="content--wrapper">
					<div class="creator--wrapper">
						<div class="creator">
							{{ item.podcastName.substring(0,25) }}{{ item.podcastName.length >= 25 ? '..' : '' }}
						</div>
						<img v-if="item.verified" src="@/assets/icons/verified.png" class="verified">
					</div>
					<div class="subtitle">{{ item.subscriber }} Subscribers</div>
				</div>
			</div>
		</div>
		<!-- Audio search -->
		<div class="heading" v-show="search.length != 0" v-if="episodeSearch.length > 0">
			<div class="title">Searching for "{{ search.substring(0,12) }}{{ search.length >= 12 ? '...' : ''}}" </div>
			<div class="subtitle">best match by audio</div>
		</div>
		<div class="heading" v-show="search.length == 0" v-if="creatorSearch.length > 0">
			<div class="title">Browse audio</div>
			<div class="subtitle">from recent upload</div>
		</div>
		<div v-for="(item, index) in episodeSearch" :key="index" :class="{'active' : $store.state.isPlaying == item.audio}" class="audio-list--wrapper">
			<div class="image--wrapper">
				<div
					@click="$router.push({ name: 'ProfileCreator', params: { id: item.uid }})"
					:style="{ backgroundImage: `linear-gradient(rgba(255,255,255, 0), rgba(0, 0, 0, .5)), url(${item.cover})` }"
					class="image-profile">
				</div>
			</div>
			<div class="content--wrapper">
				<div class="creator--wrapper">
					<div class="name">{{ item.creator }}</div>
					<div class="verified--wrapper">
						<img v-if="item.verified" src="@/assets/icons/verified.png" alt="verified" class="verify">
					</div>
				</div>
				<div @click="play(item.audio)" class="title">{{ item.title }}</div>
				<div class="date" :class="($store.state.mode === 'dark') ? 'dark-date' : 'false'">{{ humanDate(item.created_at.toDate()).fromNow() }}
					<div :class="{'active' : $store.state.isPlaying == item.audio}" class="dot"></div> {{ timeConvert(item.duration) }} min
				</div>
			</div>
			<div class="play--wrapper" v-ripple v-if="$store.state.isStoping == item.audio" @click="play(item.audio)">
				<i class="material-icons">play_circle_outline</i>
			</div>
			<div class="play--wrapper" v-ripple v-else-if="$store.state.isPlaying == item.audio" @click="pause(item.audio)">
				<i class="material-icons">pause_circle_outline</i>
			</div>
			<div class="play--wrapper" v-ripple v-else @click="play(item.audio)">
				<i class="material-icons">play_circle_outline</i>
			</div>
		</div>
	</div>
</template>
<script>
import db from '@/db'
export default {
	data() {
		return {
			search: '',
			episodes: [],
			creators: null
		}
	},
	computed: {
		creatorSearch() {
			let _this = this
			return this.creators.filter(function (item) {
				return item.podcastName.toLowerCase().indexOf(_this.search.toLowerCase()) > -1
			})
		},
		episodeSearch() {
			let _this = this
			return this.episodes.filter(function (item) {
				return item.title.toLowerCase().indexOf(_this.search.toLowerCase()) > -1
			})
		}
	},
	methods: {
		play: function(audioUrl) {
			this.$store.commit('playSound', audioUrl)
		},
		pause: function(audioUrl) {
			this.$store.commit('pauseSound', audioUrl)
		},
	},
	firestore() {
		return {
			creators : db.collection('creator').orderBy('subscriber','desc')
		}
	},
	mounted() {
		let _this = this
		db.collection('episodes').orderBy('created_at','desc').get().then((audioData) => {
			audioData.forEach(function(doc) {
				db.collection('creator').doc(doc.data().uid).get().then(function(creator) {	
					_this.episodes.push({
						audio: doc.data().audio,
						created_at: doc.data().created_at,
						duration: doc.data().duration,
						title: doc.data().title,
						listener: doc.data().listener,
						uid: doc.data().uid,
						creator: creator.data().podcastName,
						cover: creator.data().cover,
						verified: creator.data().verified
					});
				})
			})
		})
	}
};
</script>

<style lang="scss" scoped>
$base-color: #1b7b46;
$inner-color: #caefe2;
.page {
	background: #fff;
	color: #000;
	margin-bottom: 3.4rem;
}
/* DARK MODE */
.dark {
	background: #000;
	color: #fff;
}
/* HEADER */
.navbar.darkModeActive {
	background-color: #121212;
}
.navbar.false {
	background-color: white;
}
.navbar {
	position: fixed;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	width: 100%;
	height: 65px;
	top: 0;
	-webkit-box-pack: center;
	-ms-flex-pack: center;
	-ms-flex-align: center;
	align-items: center;
	z-index: 99;
	padding: 20px;
	.title {
		position: absolute;
		left: 60px;
		font-size: 16px;
	}
}
.search--wrapper {
	padding: 6rem 1.5rem 2rem;
	border-bottom: 1px solid rgba(255,255,255, .1);
	display: flex;
	flex-flow: column;
	.title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 32px;
		margin-bottom: .5rem;
		letter-spacing: -.05rem;
	}
	.input-search.dark-input-search {
		color: rgba(255,255,255,1);
		background-color: rgba(255,255,255, .15) !important;
		&::placeholder {
			color: rgba(255,255,255, .5) !important;
		}
		&:focus {
			color: rgba(255,255,255, .9) !important;		
		}
	}
	.input-search {
		height: 2.5rem;
		font-size: 12px;
		letter-spacing: .01rem;
		border-radius: 8px;
		text-indent: 1rem;
		border-style: none;
		border: none;
		font-family: GoogleSans;
		background-color: rgb(242, 242, 242);
		transition: .25s cubic-bezier(0.22, 0.61, 0.36, 1);
		&::placeholder {
			color: rgba(0,0,0, .5);
		}
		&:focus {
			outline-width: 0;
			background-color: rgb(250, 250, 250);
		}
	}
}
</style>